Vue.component("districtmap", {
  props: {
    data: { default: false },
    chosenState: {},
    group: {},
    alldistrictdata: {},
    fielddataraw: {},
    showkey: { type: Boolean, default: false },
    selectedData: {}
  },
  data() {
    return {
      districtmapid: "districtmap_" + makeID(),
      svg: false,
      path: false,
      width: 500,
      height: 500,
      districtdata: {},
      tooltip: false,
      mapDrawn: false,
      activeDataField: 20,
      quintNumber: 4,
      containsMissingData: false,
      keyedDataCache: false,
      keyedDataDataLength: false
    };
  },
  computed: {
    activeDataFieldFull() {
      let $this = this;
      if (this.activeDataField) {
        let field = this.activeDataField;
        if (this.activeDataField.toString().indexOf("_") > -1) {
          let split = this.activeDataField.split("_");
          field = split[0];
        }
        if (this.fielddataraw) {
          let f = this.fielddataraw.find((element) => element.data_field_id == field * 1);
          return f;
        }
      }
      return false;
    },
    activeDataFieldName() {
      if (!this.activeDataFieldFull) {
        return false;
      }
      return this.activeDataFieldFull.data_name;
    },
    booleanData() {
      if (!this.data) {
        return false;
      }

      if (this.data == "nodata") {
        return "nodata";
      }
      let d = {};

      for (i = 0; i < this.data.length; i++) {
        let val = +this.data[i].data_value;
        let nces = this.data[i].nces_id;
        if (val > 0) {
          d[nces] = 1;
        } else {
          d[nces] = 0;
        }
      }
      return d;
    },
    activeData() {
      switch (this.group) {
        case "boolean":
          return this.booleanData;
        default:
          return this.data;
      }
    },
    keyedData() {
      if (!this.data) {
        return false;
      }
      let d = {};
      let $this = this;
      // USE DATA LENGTH TO AVOID EXTRA LOOPS
      if (this.keyedDataCache && this.keyedDataDataLength == this.data.length) {
        return this.keyedDataCache;
      }

      this.data.forEach(function (el) {
        let val = +el.data_value;
        let nces = el.nces_id;
        let field = el.data_field_id;

        if (
          SLIDEStaffingFields.includes(+field) &&
          $this.selectedData.selected.filters.staffing_years &&
          ($this.selectedData.selected.filters.staffing_years.length > 1 ||
            ($this.selectedData.selected.filters.staffing_years.length == 1 &&
              $this.selectedData.selected.filters.staffing_years[0] != SLIDEActiveYear))
        ) {
          field = field + "_" + el.data_year;
        }
        if (!d[nces]) {
          d[nces] = {};
        }
        d[nces][field] = val;
      });

      this.keyedDataCache = d;
      this.keyedDataDataLength = this.data.length;
      return d;
    },
    dataFields() {
      if (!this.keyedData) {
        return false;
      }
      let [firstKey] = Object.keys(this.keyedData);
      let arr = Object.keys(this.keyedData[firstKey]);
      return arr;
    },
    quintiles() {
      if (!this.activeDataField || !this.quintNumber) {
        return false;
      }

      let k = this.activeDataField;
      let num = this.quintNumber;
      let arr = [];
      for (const st in this.keyedData) {
        if (this.keyedData[st][k] || this.keyedData[st][k] === 0) {
          arr.push(this.keyedData[st][k] * 1);
        }
      }
      arr.sort(function (a, b) {
        return a - b;
      });
      let q = {};
      q[0] = 0;
      for (let i = 1; i < num; i++) {
        let fraction = 100 / num;
        let thisF = (fraction * i) / 100;
        q[i] = thisF;
      }
      let quintiles = {};
      activeQ = 0;
      for (k in q) {
        let i = q[k] * arr.length;
        if (Math.floor(i) == i) {
          result = (arr[i - 1] + arr[i]) / 2;
        } else {
          result = arr[Math.floor(i)];
        }
        if (k == 0 || result != quintiles[activeQ - 1]) {
          if (isNaN(result)) {
            result = 0;
          }
          quintiles[activeQ] = result;
          activeQ++;
        }
      }
      return quintiles;
    },
    quintLabels() {
      if (!this.quintiles) {
        return false;
      }
      let labels = {};
      let num = Object.keys(this.quintiles).length;

      let f = this.activeDataFieldFull;
      let t = "text";
      if (f.data_format) {
        t = f.data_format;
      }

      for (let i = 0; i < num; i++) {
        if (i == 0) {
          labels[i] = "0";
          if (f.wholenumbers || t == "Number") {
            if (this.quintiles[1] == 1) {
              continue;
            }
            labels[i] += "-" + formatSlideData(this.quintiles[1] - 1, t);
            continue;
          }
          labels[i] += "-" + formatSlideData(this.quintiles[1] - 0.01, t);
          continue;
        }
        if (i == 1) {
          labels[i] = "";
          if (f.wholenumbers || t == "Number") {
            if (this.quintiles[1] == this.quintiles[2] - 1) {
              labels[i] = formatSlideData(this.quintiles[1], t);
            } else {
              labels[i] =
                formatSlideData(this.quintiles[1], t) +
                "-" +
                formatSlideData(this.quintiles[2] - 1, t);
            }
            continue;
          }
          if (this.quintiles[2]) {
            labels[i] =
              formatSlideData(this.quintiles[1], t) +
              "-" +
              formatSlideData(this.quintiles[2] - 0.01, t);
          } else {
            labels[i] = formatSlideData(this.quintiles[1], t) + "+";
          }

          continue;
        }
        if (i == num - 1) {
          labels[i] = formatSlideData(this.quintiles[i], t) + "+";
          continue;
        }
        let n = i + 1;
        if (f.wholenumbers || t == "Number") {
          if (this.quintiles[i] == this.quintiles[n] - 1) {
            labels[i] = formatSlideData(this.quintiles[i], t);
          } else {
            if (f.wholenumbers) {
              labels[i] =
                formatSlideData(this.quintiles[i], t) +
                "-" +
                formatSlideData(this.quintiles[n] - 1, t);
              continue;
            }
            labels[i] =
              formatSlideData(this.quintiles[i], t) +
              "-" +
              formatSlideData(this.quintiles[n] - 1, t);
          }
          continue;
        }
        labels[i] =
          formatSlideData(this.quintiles[i], t) +
          "-" +
          formatSlideData(this.quintiles[n] - 0.01, t);
      }
      return labels;
    },
    keyVizualization() {
      let labels = this.quintLabels;
      if (!labels) {
        return false;
      }
      let html = "";

      html += '<div class="map_key_display_robust_wrapper">';
      for (let i = 0; i < Object.keys(labels).length; i++) {
        let opac = 0.1;
        opac = this.getOpac(i + 1, Object.keys(labels).length);
        html += '<div class="map_key_display_robust">';
        html +=
          '<div class="map_key_display" style="background-color: rgba(0, 85, 162, ' +
          opac +
          ')"></div>';
        html += labels[i];
        html += "</div>";
      }
      html += "</div>";
      return html;
    },
    tooltipid() {
      return "tooltip_" + this.districtmapid;
    }
  },
  watch: {
    activeData(val) {
      if (val && this.chosenState) {
        this.setData();
      }
    }
  },

  async created() {
    if (!this.chosenState || !this.activeData) {
      return;
    }
    this.setData();
  },
  mounted() {
    d3.select(window).on("resize", this.scaleMap);
  },
  methods: {
    setTooltip() {
      if (document.getElementById(this.tooltipid)) {
        return;
      }
      let $this = this;
      this.tooltip = d3
        .select("body")
        .append("div")
        .attr("class", "map_tooltip")
        .attr("id", $this.tooltipid)
        .style("opacity", 0);
    },
    async setData() {
      if (!this.chosenState || !this.chosenState.FIPS) {
        return;
      }

      if (this.showkey) {
        this.activeDataField = this.dataFields[0];
      } else if (this.data) {
        this.activeDataField = this.data[0].data_field_id;
      }

      if (this.showKey) {
        this.activeDataField = this.datafields[0];
      }
      this.setTooltip();
      this.scaleMap();
      let $this = this;
      $this.svg = d3
        .select("#" + $this.districtmapid + " svg")
        .attr("width", $this.width)
        .attr("height", $this.height);
      let ds =
        "/wp-content/themes/slide/assets/data/districtmaps/state-" +
        this.chosenState.FIPS +
        ".json";
      d3.json(ds).then(function (json) {
        let f = json.features;

        for (i = 0; i < f.length; i++) {
          let n = f[i].properties.nces_id;
          $this.districtdata[n] = f[i].properties;
          $this.districtdata[n]["data"] = $this.activeData[n];

          if ($this.activeData[n] == "undefined") {
            $this.districtdata[n]["data"] = $this.activeData[n] = "-";
          }
        }
        $this.drawMap();
      });
    },
    drawMap() {
      let $this = this;
      // remove overlay
      if (document.getElementById($this.districtmapid + "_overlay")) {
        document.getElementById($this.districtmapid + "_overlay").remove();
      }

      if (!this.mapDrawn) {
        d3.json(
          "/wp-content/themes/slide/assets/data/districtmaps/state-" +
            this.chosenState.FIPS +
            ".json"
        ).then(function (json) {
          var center = d3.geoPath().centroid(json);
          var scale = 3000;
          var offset = [$this.width / 2, $this.height / 2];
          var projection = d3.geoMercator().scale(scale).center(center).translate(offset);
          var path = d3.geoPath().projection(projection);
          var width = $this.width;
          var height = $this.height;

          // using the path determine the bounds of the current map and use
          // these to determine better values for the scale and translation
          var bounds = path.bounds(json);
          var hscale = (scale * width) / (bounds[1][0] - bounds[0][0]);
          var vscale = (scale * height) / (bounds[1][1] - bounds[0][1]);

          var scale = hscale < vscale ? hscale : vscale;
          var offset = [
            width - (bounds[0][0] + bounds[1][0]) / 2,
            height - (bounds[0][1] + bounds[1][1]) / 2
          ];

          // ADJUST FOR HAWAII & ALASKA
          if ($this.chosenState.abbr == "HI") {
            offset = [250, 200];
            scale = 3000;
          }
          if ($this.chosenState.abbr == "AK") {
            offset = [250, 200];
            scale = 500;
          }

          // new projection
          projection = d3.geoMercator().center(center).scale(scale).translate(offset);
          path = path.projection(projection);

          $this.svg
            .selectAll("path")
            .data(json.features)
            .enter()
            .append("path")
            //.attr("d", $this.path)
            .attr("d", path)
            .attr("id", function (d) {
              return "district-" + d.properties.nces_id;
            })
            .style("stroke-width", "1")
            .style("stroke", "#fff")
            .style("fill", function (d) {
              return $this.setFillColor(d.properties.nces_id);
            })
            .on("mouseover", function (event, d) {
              $this.mouseover(event, d);
            })
            .on("mouseout", function (event, d) {
              $this.tooltip.transition().duration(500).style("opacity", 0);
            });
        });
      } else {
        this.svg
          .transition()
          .selectAll("path")
          .style("fill", function (d) {
            return $this.setFillColor(d.properties.nces_id);
          });
      }

      if (this.activeData == "nodata") {
        setTimeout(function () {
          $this.svg
            .insert("text")
            .attr("id", $this.districtmapid + "_overlay")
            .text(function (d) {
              return "(   No Data   )";
            })
            .attr("width", $this.width)
            .attr("x", "50%")
            .attr("y", "50%")
            .attr("text-anchor", "middle")
            .attr("filter", "url(#solid)")
            .attr("transform", "rotate(30, " + $this.width / 2 + ", " + $this.height / 2 + ")");
        }, 1000);
      }
      this.mapDrawn = true;
    },

    setFillColor(nces) {
      let $this = this;
      //let active = $this.svg.select('district-' + nces);
      let opac = 0.1;
      if (!$this.keyedData[nces]) {
        $this.containsMissingData = true;
        return "#4a4a4a";
      } else {
        let val = $this.keyedData[nces][$this.activeDataField];

        if (
          $this.group == "boolean" &&
          $this.districtdata[nces] &&
          $this.districtdata[nces]["data"] == 1
        ) {
          opac = 0.9;
        }
        if ($this.group != "boolean") {
          opac = this.getColorOpacityForScale(val);
        }
      }

      if (opac > 0.89) {
        return "#0055a2";
      }
      if (opac > 0.6) {
        return "#556fac";
      }
      if (opac > 0.4) {
        return "#759af0";
      }
      if (opac > 0.2) {
        return "#96b6ff";
      }
      return "#cfd5e5";
      return "rgba(0, 85, 162, " + opac + ")";
    },
    getColorOpacityForScale(v) {
      let opac = 0.1;

      let num = Object.keys(this.quintiles).length;
      for (let i = num; i > 0; i--) {
        if (v >= this.quintiles[i]) {
          opac = this.getOpac(i + 1, num);
          break;
        }
      }
      if (v == undefined) {
        opac = 0;
      }
      return opac;
    },
    getOpac(num, denom) {
      return (num / denom) * 0.8;
    },
    mouseover(event, d) {
      let $this = this;
      if (!document.getElementById($this.tooltipid)) {
        $this.setTooltip();
      }
      let pageX = event.pageX;
      let pageY = event.pageY;
      pageX = event.clientX;
      pageY = event.clientY;
      let html = "";
      let nces = d.properties.nces_id;

      if ($this.alldistrictdata[nces] && $this.alldistrictdata[nces].agency_name) {
        let districtname = $this.alldistrictdata[nces].agency_name;
        html +=
          districtname +
          ": " +
          formatSlideData(
            $this.keyedData[nces][$this.activeDataField],
            $this.activeDataFieldFull.data_format
          );
        $this.tooltip.transition().duration(200).style("opacity", 0.95);
        $this.tooltip
          .html(html)
          .style("left", pageX + 5 + "px")
          .style("top", pageY - 30 + "px");
      }
    },
    scaleMap() {
      if (document.getElementById(this.districtmapid)) {
        this.width = document.getElementById(this.districtmapid).offsetWidth;
        this.height = this.width;
        this.drawMap();
      }
    },
    getFieldName(key) {
      if (key.indexOf("_") > -1) {
        let keysplit = key.split("_");
        let f = this.fielddataraw.find((element) => element.data_field_id == keysplit[0]);
        return f.data_name + " (" + keysplit[1] + ")";
      }
      let f = this.fielddataraw.find((element) => element.data_field_id == key);

      return f.data_name;
    },
    updateKeySelect() {
      return;
    }
  }
});
